import type { ReactNode } from "react";
import { BookOpen } from "lucide-react";

export default function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div
      className="flex min-h-screen items-center justify-center px-4"
      style={{
        background:
          "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(37,99,235,0.10) 0%, transparent 60%)," +
          "#f8fafc",
      }}
    >
      <div className="card w-full max-w-md p-8 shadow-soft-lg">
        <div className="mb-6 flex items-center gap-2.5">
          <div
            className="flex h-7 w-7 items-center justify-center rounded-md text-white"
            style={{ background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)" }}
          >
            <BookOpen className="h-3.5 w-3.5" />
          </div>
          <span className="font-display text-base font-semibold tracking-tight text-slate-900">
            ScholarPetition
          </span>
        </div>
        {children}
      </div>
    </div>
  );
}
